import React, { memo } from "react";
import { formatTimeFromUtc } from "../../../../utils/formatters";
import { icons } from "constants/icons";

type Props = {
  jointName: string;
  side?: string;
  painScale: string | number;
  survey: string | number;
  type: string;
  rightMin: string | number;
  rightMax: string | number;
  leftMin: string | number;
  leftMax: string | number;
  range: string | number;
  createdDate: string;
};
export const VideoExamTableRow = memo(
  ({
    jointName,
    side,
    painScale,
    survey,
    type,
    rightMin,
    rightMax,
    leftMin,
    leftMax,
    range,
    createdDate,
  }: Props) => {
    return (
      <div className="flex w-full bg-bgLight border border-border rounded-lg p-3 text-grayDark">
        <div className="flex space-x-4 items-center" style={{ width: 200 }}>
          <img src={icons.patientShoulder} alt="status" />
          <p>
            <strong className="capitalize font-normal">{jointName}</strong>
            {side && <strong className="font-normal ml-1">({side})</strong>}
          </p>
          <p />
        </div>
        <div className="text-center" style={{ width: 200 }}>
          <p>{side === "right" ? rightMin : leftMin}</p>
        </div>
        <div className="text-center" style={{ width: 200 }}>
          <p>{side === "right" ? rightMax : leftMax}</p>
        </div>
        <div className="text-center" style={{ width: 200 }}>
          <p>{survey}</p>
        </div>
        <div className="text-center" style={{ width: 200 }}>
          <p>{formatTimeFromUtc(createdDate)}</p>
        </div>
      </div>
    );
  }
);
